import { useEffect } from 'react'
import { AppConfig, AppConfigActions } from '@AppState/app-config'
import { useAppDispatch } from '@AppState/redux-store'

export const AppConfigLoader = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    console.log(`💠 Loading App Config`)

    const appConfig: AppConfig = {
      // A local back-office-service can be targeted with VITE_BACK_OFFICE_BASE_PATH while the Auth0 audience
      // (authConfig) keeps using VITE_BACK_OFFICE_DATA_SERVICE_URL, so login still works against a local API
      backOfficeDataServiceUrl:
        import.meta.env.VITE_BACK_OFFICE_BASE_PATH ||
        import.meta.env.VITE_BACK_OFFICE_DATA_SERVICE_URL,
    }

    dispatch(AppConfigActions.setAppConfig(appConfig))
  }, [dispatch])

  return <></>
}
